import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { Text, Button } from 'mintel-react-ui';

import useTranslation from '../../translations';
import { DjangoPageMessages, StringField } from '../../fields';
import { changeLanguage, handleEmailSubmit } from '../../shared/utils';
import { EmailInputWrapper } from '../../InputWrapper';
import PageWrapper from '../../PageWrapper';
import styles from './EmailRegistrationForm.scss';

export type EmailRegistrationFormProps = DjangoPageMessages & {
  backLink: string;
  fields: {
    email: StringField;
    csrf: StringField;
  };
  language?: string;
};

const EmailRegistrationForm = ({
  fields,
  backLink,
  language = 'en',
  info = [],
  errors = [],
}: EmailRegistrationFormProps): JSX.Element => {
  const { t } = useTranslation();
  useEffect(() => {
    changeLanguage(language);
  }, [language]);
  const [email, setEmail] = useState(fields.email.value || '');
  const [error, setError] = useState<string | null>(null);

  const onCancel = () => {
    window.location.pathname = backLink;
  };

  const stepNumber = 1;
  const totalSteps = 3;

  // TODO Must come back to this and resolve duplication flagged up by Sonar
  return (
    <PageWrapper infos={info} errors={errors}>
      <form method="POST" className={styles.root}>
        <div className={styles.title}>
          <Text.Heading2>{t('Registration')}</Text.Heading2>
        </div>
        <div className={styles.description}>
          <Text.Body>
            <Trans>
              Step <b>{{ stepNumber }}</b> of <b>{{ totalSteps }}</b>
            </Trans>
          </Text.Body>
        </div>
        <div className={styles.description}>
          <Text.Body2>
            {t(
              'Please enter your email address. You will be sent an email contaning a link that will grant you access to your Mintel services.',
            )}
          </Text.Body2>
        </div>
        <EmailInputWrapper
          fields={fields}
          email={email}
          error={error}
          setEmail={setEmail}
          setError={setError}
        />
        <div className={styles.buttonRow}>
          <div className={styles.button}>
            <Button.CancelButton secondary fullWidth handleClick={onCancel} />
          </div>
          <div className={styles.button}>
            <Button.ActionButton
              type="submit"
              disabled={!email.length}
              fullWidth
              handleClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                handleEmailSubmit(e, email, t, setError);
              }}
              status={Button.Status.DEFAULT}
            >
              {t('Send Email')}
            </Button.ActionButton>
          </div>
        </div>
        <div className={styles.backButton}>
          <Text.Body2>
            <a href={backLink || '/'}>{t('Back to login')}</a>
          </Text.Body2>
        </div>
      </form>
    </PageWrapper>
  );
};

export default EmailRegistrationForm;
